// 토큰 수 배지 (KBNL-68).
//
// 모든 콘텐츠 (SV / CV / SQL / Virtual Schema / Instruction / Sandbox 메시지)
// 의 사이드바 / 헤더에 일관된 모양으로 노출되는 작은 배지.
//
// count = null/undefined 면 '—' 표시 (token counter 비활성 또는 옛 doc 미기록).
// count = 정수 면 1234t / 12.3K t / 1.2M t 형식으로 압축 표시.
// title 속성에 정수 전체값 노출 (마우스 hover 시).

function fmt(n) {
  if (n == null || isNaN(n)) return '—'
  if (n < 1000) return `${n}t`
  if (n < 1_000_000) {
    const k = (n / 1000).toFixed(1).replace(/\.0$/, '')
    return `${k}K t`
  }
  const m = (n / 1_000_000).toFixed(1).replace(/\.0$/, '')
  return `${m}M t`
}

// variant: 'default' (사이드바 작은 배지) | 'strong' (본문 패널 헤더, 더 진한 배경)
export default function TokenBadge({ count, title, variant = 'default' }) {
  const empty = count == null || isNaN(count)
  const variantCls = variant === 'strong' ? ' tok-badge-strong' : ''
  const cls = (empty ? 'tok-badge tok-badge-empty' : 'tok-badge') + variantCls
  const tip = title || (empty
    ? '토큰 수 미기록 — 다음 저장 시 자동 채워짐'
    : `${count.toLocaleString()} 토큰`)
  return <span className={cls} title={tip}>{fmt(count)}</span>
}
